"use strict";

jQuery(document).ready(function ($) {
  function sendHeight(tabContent) {
    //   console.log('sendHeight');

    // Get references to elements
    var iframeTabsHeader = document.querySelector('.qualification-iframe__header');
    var iframeTabContent = document.querySelector(tabContent);
    if (iframeTabsHeader && iframeTabContent) {
      var heightIframeTabs = iframeTabsHeader.clientHeight;
      var heightIframeTabContent = iframeTabContent.clientHeight;
      var heightIframeTotal = heightIframeTabs + heightIframeTabContent;

      //   console.log('Tab content' + tabContent);
      //   console.log('Tab heightIframeTabs ' + heightIframeTabs);
      //   console.log('Tab heightIframeTabContent ' + heightIframeTabContent);
      //   console.log('Tab heightIframeTotal ' + heightIframeTotal);

      if (heightIframeTotal != null && !isNaN(heightIframeTotal)) {
        //    console.log('PostMessage from Child ' + heightIframeTotal);
        window.parent.postMessage({
          heightIframeContent: heightIframeTotal
        }, "*");
      } else {
        //  console.log('Height is undefined or null');
      }
    } else {
      // console.log('One or both of the elements not found');
    }
  }

  // Send height on button click
  $('.qualification-iframe__header .btn').on('click', function () {
    var selected = $(this);
    var target = selected.data('target');
    $('.qualification-iframe__header .btn').removeClass('active');
    selected.addClass('active');
    $('.qualification-iframe__tab').removeClass('active');
    $('#' + target).addClass('active');
    sendHeight('#' + target);
  });

  // Add resize event on the window with debounce
  var resizeTimeout;
  $(window).on('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      var dataTargetValue = $('.buttons .btn.active').data('target');
      sendHeight('#' + dataTargetValue);
    }, 200);
  });

  // Retry mechanism for initial message
  function retrySendHeight() {
    var retryCount = 0;
    var maxRetries = 5;
    var interval = setInterval(function () {
      if (retryCount < maxRetries) {
        sendHeight('#qualification-overview');
        retryCount++;
      } else {
        clearInterval(interval);
      }
    }, 200);
  }

  // Ensure parent readiness with listener
  window.addEventListener("message", function (event) {
    if (event.data && event.data.type === "parent-ready") {
      sendHeight('#qualification-overview');
    }
  });

  // Initial call with retry fallback
  retrySendHeight();
});
document.addEventListener("DOMContentLoaded", function () {
  // Check if the current domain is qualifications.vtct.org.uk
  var currentDomain = window.location.hostname;
  var targetDomain = 'qualifications.vtct.org.uk';
  var targetDomainStaging = 'media.carswellgould.uk';
  if (currentDomain === targetDomain || currentDomain === targetDomainStaging) {
    var baseUrl;
    if (currentDomain === targetDomain) {
      baseUrl = 'https://www.vtctskills.org.uk/cg__proxy_download.php?file=';
    } else if (currentDomain === targetDomainStaging) {
      baseUrl = 'https://vtct.carswellgould.co.uk/cg__proxy_download.php?file=';
    } else {
      return; // Exit if the current domain doesn't match the expected domains
    }

    var links = document.querySelectorAll('a.related-links__link--button');
    links.forEach(function (link) {
      // Remove target="_new" attribute if present
      if (link.getAttribute('target') === '_new') {
        link.removeAttribute('target');
      }

      // const relativePath = link.getAttribute('href');
      // // Correctly URL encode the path
      // const encodedPath = encodeURIComponent(relativePath);
      // // Replace encoded backslashes with forward slashes
      // const correctedPath = encodedPath.replace(/%5C/g, '/');
      // link.setAttribute('href', baseUrl + correctedPath);

      var relativePath = link.getAttribute('href');
      // console.log(relativePath);
      // Decode the URL-encoded path
      var decodedPath = decodeURIComponent(relativePath);
      // Replace backslashes with forward slashes
      var correctedPath = decodedPath.replace(/\\/g, '/');
      // Normalize the path (e.g., remove '..' if necessary, or handle them)
      var normalizedPath = correctedPath.replace(/\/\.\.\//g, '/'); // Simple normalization example

      // Correctly format the path
      link.setAttribute('href', baseUrl + normalizedPath);

      // console.log(baseUrl + normalizedPath);
    });
  }
});